"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LayoutWrapper = exports.Container = exports.Item = exports.Col = void 0;
var react_1 = __importDefault(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var spacing_1 = require("./spacing");
var layout_1 = require("../util/layout");
var genSizeRule = function (cols) {
    if (!cols)
        return '';
    return "width: ".concat((cols / 12) * 100, "%;");
};
var genMediaSizeRule = function (breakPoint, cols) {
    return "@media (max-width: ".concat(breakPoint, "px) {\n     ").concat(genSizeRule(cols), "\n   }\n");
};
var genFlexRules = function (_a) {
    var center = _a.center, direction = _a.direction, align = _a.align, justify = _a.justify, gap = _a.gap, rowGap = _a.rowGap;
    var rules = '';
    if (center)
        rules += "\n      justify-content: center;\n      align-items: center;\n    ";
    if (direction)
        rules += "flex-direction: ".concat(direction, ";");
    if (align)
        rules += "align-items: ".concat(align, ";");
    if (justify)
        rules += "justify-content: ".concat(justify, ";");
    if (gap)
        rules += "gap: ".concat((0, layout_1.space)(gap), ";");
    if (rowGap)
        rules += "row-gap: ".concat((0, layout_1.space)(rowGap), ";");
    return rules;
};
var genItemRules = function (_a) {
    var cols = _a.cols, xsCols = _a.xsCols, smCols = _a.smCols, mdCols = _a.mdCols, lgCols = _a.lgCols, center = _a.center, direction = _a.direction, align = _a.align, justify = _a.justify, gap = _a.gap, rowGap = _a.rowGap;
    var rules = genSizeRule(cols);
    var colCounts = {
        // off by one for < media queries
        sm: xsCols,
        md: smCols,
        lg: mdCols,
        xl: lgCols,
    };
    Object.keys(colCounts).forEach(function (bpName) {
        if (colCounts[bpName])
            rules += genMediaSizeRule((0, layout_1.breakPoint)(bpName), colCounts[bpName]);
    });
    if (center || direction || align || justify)
        rules += 'display: flex;';
    rules += genFlexRules({ center: center, direction: direction, align: align, justify: justify, gap: gap, rowGap: rowGap });
    return rules;
};
var generateMaxWidthRule = function (size) {
    if (!(0, layout_1.layoutWidth)(size))
        return;
    return "@media (min-width: ".concat((0, layout_1.breakPoint)(size), "px) {\n    max-width: ").concat((0, layout_1.layoutWidth)(size), "px;\n  }\n");
};
exports.Col = (0, styled_components_1.default)(react_1.default.forwardRef(function (_a, ref) {
    var wrap = _a.wrap, center = _a.center, direction = _a.direction, align = _a.align, justify = _a.justify, rest = __rest(_a, ["wrap", "center", "direction", "align", "justify"]);
    return (react_1.default.createElement(spacing_1.SpacingContainer, __assign({}, rest, { ref: ref })));
}))(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n"], ["\n  ", "\n"
    // DEPRECATED: Item preserved for backward compatibility. Col is a more explicit
    // name that should be used going forward.
])), function (props) { return genItemRules(props); });
// DEPRECATED: Item preserved for backward compatibility. Col is a more explicit
// name that should be used going forward.
exports.Item = exports.Col;
exports.Container = (0, styled_components_1.default)(react_1.default.forwardRef(function (_a, ref) {
    var wrap = _a.wrap, center = _a.center, direction = _a.direction, align = _a.align, justify = _a.justify, rest = __rest(_a, ["wrap", "center", "direction", "align", "justify"]);
    return react_1.default.createElement(spacing_1.SpacingContainer, __assign({}, rest, { ref: ref }));
}))(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-wrap: ", ";\n  ", "\n"], ["\n  display: flex;\n  flex-wrap: ", ";\n  ", "\n"])), function (_a) {
    var _b = _a.wrap, wrap = _b === void 0 ? true : _b;
    return (wrap ? 'wrap' : 'nowrap');
}, function (_a) {
    var center = _a.center, direction = _a.direction, align = _a.align, justify = _a.justify, gap = _a.gap, rowGap = _a.rowGap;
    return genFlexRules({ center: center, direction: direction, align: align, justify: justify, gap: gap, rowGap: rowGap });
});
exports.LayoutWrapper = (0, styled_components_1.default)(spacing_1.SpacingContainer)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 100%;\n  padding-left: ", ";\n  padding-right: ", ";\n  margin-left: auto;\n  margin-right: auto;\n\n  ", "\n"], ["\n  width: 100%;\n  padding-left: ", ";\n  padding-right: ", ";\n  margin-left: auto;\n  margin-right: auto;\n\n  ", "\n"])), (0, layout_1.space)(2), (0, layout_1.space)(2), layout_1.sizes.map(generateMaxWidthRule));
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=grid.js.map